/** Installed hearing panel v2 owns the same population consumed by generic voting rounds. */
export function providesVotingBlock(
  block: {
    provider: string;
    code: string;
    version: number;
    settingsVersion: number;
  },
  code: string,
): boolean {
  return (
    (block.provider === 'voting' && block.code === code) ||
    (code === 'voting.population' && isHearingPanelPopulation(block)) ||
    (code === 'voting.result' && isCombinedVotingRound(block))
  );
}
export function isCombinedVotingRound(block: {
  provider: string;
  code: string;
  version: number;
  settingsVersion: number;
}): boolean {
  return (
    block.provider === 'voting' &&
    block.code === 'voting.ballots' &&
    block.version === 2 &&
    block.settingsVersion === 1
  );
}
export function isHearingPanelPopulation(block: {
  provider: string;
  code: string;
  version: number;
  settingsVersion: number;
}): boolean {
  return (
    block.provider === 'hearing' &&
    block.code === 'hearing.panel' &&
    block.version === 2 &&
    block.settingsVersion === 1
  );
}
